import Plyr from 'plyr-react'
import "plyr-react/plyr.css";

export default function VideoPlayer({ src = '/mov_bbb.mp4', type = "video/mp4" }) {

  const plyrProps = {
    source: {
      type: "video",
      sources: [
        {
          src,
          type,
          size: 720
        }
      ]
    }, // https://github.com/sampotts/plyr#the-source-setter
    options: {
      controls: ["rewind", "play", "fast-forward", "progress", "current-time", "duration", "mute", "volume", "settings", "pip", "fullscreen"],
      settings: ['quality', 'speed'],
      quality: { default: 576, options: [4320, 2880, 2160, 1440, 1080, 720, 576, 480, 360, 240] }
    }, // https://github.com/sampotts/plyr#options
    // Direct props for inner video tag (mdn.io/video)
  }
  return (
    <Plyr {...plyrProps} />
  );
}
